const history =  require("history").createHashHistory({
  queryKey: false
});
export default history;